<template>
  <div>
    <div class="box">
      <h2 class="title">{{$t('historic.header.title')}}</h2>

      <div v-if="isLoading">
        <p class="loading historic-loading">{{$t('historic.loading')}}</p>
      </div>
      <div v-else class="historic-list is-narrow" data-simplebar>
        <!--historic-item v-if="pendingOrder" :data="pendingOrder" @click="viewPendingOrder(pendingOrder)"></historic-item-->

        <div v-if="historic.length > 0">
          <div class="historic-list-content">
            <historic-item
              v-for="item in historic"
              :key="item.id"
              :data="item"
              @click="view(item)"
            ></historic-item>
          </div>
          <button
            class="button is-text is-medium"
            v-if="nextPage"
            @click="loadData($event)"
          >
            {{$t('historic.loadMore')}}
          </button>
        </div>
        <div v-else>
          <p class="historic-empty">
            {{$t('historic.empty')}}<br />
            {{ $root.app.service }}
          </p>
        </div>
      </div>
    </div>

    <zul-modal
      id="view-receipt"
      class="is-medium"
      ref="viewModal"
      title="Comprovante"
      @secondary="cancelPurchase"
    >
      <div v-if="!viewData">
        <div class="loading">{{$t('global.loading')}}</div>
      </div>
      <div v-else class="receipt">
        <div class="receipt-origin">
          <span
            :class="{
              icon: true,
            }"
          >
            <img
              :src="viewData.icon['@1x']"
              :srcset="`${viewData.icon['@1x']} 1x, ${viewData.icon['@2x']} 2x, ${viewData.icon['@3x']} 3x`"
            />
          </span>
          <div class="receipt-description" v-if="viewData.cityName">
            <span>{{ viewData.cityName }}</span>
            <span>{{ viewData.title }}</span>
          </div>
          <div class="receipt-date">
            <span>{{ viewData.date | moment("DD MMM[.] YYYY") }}</span>
            <span>{{ viewData.date | moment("HH:mm") }}</span>
          </div>
        </div>
        <div
          class="receipt-detail"
          v-if="!!(viewData.additionalInfos || []).length"
        >
          <div v-for="info in viewData.additionalInfos" :key="info.title">
            <span class="receipt-label">{{ info.title }}</span>
            <span class="receipt-value">{{ info.value }}</span>
          </div>
        </div>

        <div class="receipt-detail">
          <div v-if="viewData.summary">
            <span class="receipt-label">{{$t('historic.label')}}</span>
            <span class="receipt-value">
              <span class="summary-icon">
                <img
                  :src="((viewData.summary || {}).image || [])['@1x']"
                  :srcset="`${((viewData.summary || {}).image || [])['@1x']} 1x,
              ${((viewData.summary || {}).image || [])['@2x']} 2x,
              ${((viewData.summary || {}).image || [])['@3x']} 3x`"
                />
                {{ (viewData.summary || {}).detail || "" }}
              </span>
            </span>
          </div>

          <div v-if="viewData.value !== undefined">
            <span class="receipt-label">{{$t('historic.total')}}</span>
            <span class="receipt-value">
              <span
                :class="{
                  'receipt-amount': true,
                  'payment-declined': viewData.isDeclined,
                }"
                >{{ viewData.value }}</span
              >
            </span>
          </div>
        </div>
        <div class="receipt-reference">
          <span class="reference-label">{{
            viewData.referenceNumberLabel
          }}</span>
          <span class="reference-number">{{ viewData.referenceNumber }}</span>
        </div>
        <div v-if="viewData.footerNotes" class="receipt-footerNotes">
          <hr />
          <p>{{ viewData.footerNotes }}</p>
        </div>
      </div>
    </zul-modal>

    <zul-modal
      id="cancel-order"
      ref="cancelModal"
      class="is-medium"
      title="Cancelar compra"
      @primary="confirmCancel"
    >
      <div v-if="!cancelData">
        <div class="loading">{{$t('global.loading')}}</div>
      </div>
      <div v-else-if="cancelSuccess">
        <div class="success">
          {{$t('historic.success')}}
        </div>
      </div>
      <div v-else>
        <div class="notification" v-html="cancelData.description"></div>

        <div class="body">
          <h3 class="title" v-html="cancelData.message.title"></h3>
          <p v-html="cancelData.message.body"></p>
        </div>

        <p class="warning">
          {{$t('historic.warning')}}
        </p>
      </div>
    </zul-modal>
  </div>
</template>

<script>
import HistoricItem from "./HistoricItem.vue";

export default {
  data() {
    return {
      historic: [],
      viewData: null,
      cancelData: null,
      cancelSuccess: false,
      nextPage: 1,
      isLoading: false,
    };
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.$root.$on("view-receipt-end", () => {
      this.viewData = null;
      this.$refs.viewModal.setProps({ labels: { secondary: "" } });
    });

    this.$root.$on("cancel-order-end", () => {
      this.cancelData = null;
      this.cancelSuccess = false;
      this.$refs.cancelModal.setProps({ labels: { primary: "" } });
    });

    this.$root.$on("reload-historic", () => {
      this.nextPage = 1;
      this.historic = [];
      this.loadData();
    });
  },
  methods: {
    loadData($event) {
      const $button = ($event || {}).target;

      if (this.historic.length === 0) {
        this.isLoading = true;
      }

      if ($button) {
        $button.classList.add("is-loading");
      }

      this.$http
        .get(`/history/list?page=${this.nextPage}`)
        .then((res) => {
          this.isLoading = false;

          if (res.status === 200) {
            this.historic = this.historic.concat(res.data.results);
            this.nextPage = res.data.nextPage;

            if ($button) {
              $button.classList.remove("is-loading");
            }
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    view(data) {
      const endpoint = `history/${data.type}/${data.id}`;

      this.$refs.cancelModal.close();
      this.$refs.viewModal.open();

      this.$http.get(endpoint).then((res) => {
        this.viewData = data;
        this.viewData.title = res.data.title
          .replace(/\n/g, "<br>")
          .replace(/\*/g, "");

        this.viewData.additionalInfos = res.data.additionalInfos;

        this.viewData.referenceNumberLabel = res.data.referenceNumberLabel;
        this.viewData.referenceNumber = res.data.referenceNumber;

        this.viewData.isDeclined =
          this.viewData.value.toLowerCase().indexOf("recusado") > -1;

        this.viewData.value = res.data.value;
        this.viewData.icon = res.data.icon;

        this.viewData.footerNotes = res.data.footerNotes;

        if (res.data.cancelButtonVisible) {
          this.$refs.viewModal.setProps({
            labels: {
              secondary: res.data.cancelButtonVisible
                ? this.$t('historic.askConfirm')
                : null,
            },
          });
        }
      });
    },

    cancelPurchase() {
      const orderId = this.viewData.id;
      this.$refs.viewModal.close();
      this.$refs.cancelModal.open();

      this.$http.get(`/order/${orderId}/request-cancel`).then((res) => {
        if (res.status === 206) {
          this.cancelData = res.data;
          this.cancelData.id = orderId;

          this.$refs.cancelModal.setProps({
            labels: { primary: this.$t('historic.cancelButton') },
          });
        }
      });
    },

    confirmCancel() {
      this.$refs.cancelModal.startLoading();

      this.$http
        .put(`/order/${this.cancelData.id}/request-cancel`)
        .then((res) => {
          this.$refs.cancelModal.stopLoading();

          if (res.status === 200) {
            this.cancelSuccess = true;
            this.$refs.cancelModal.setProps({ labels: { primary: null } });

            this.$root.$emit("update-user-funds");
          }
        });
    },
  },
  components: {
    HistoricItem,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/sass/variables";

.box {
  margin-bottom: 0 !important;

  > div {
    height: 100%;
  }
}

.historic-list {
  max-height: 95%;

  .button {
    margin-top: 0.5rem;
    padding: 1rem 0 1rem;
    width: 100%;
  }

  .historic-list-content {
    padding-bottom: 0;
  }
}

.historic-loading {
  height: 100%;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;

  background-position: center 40% !important;
  padding: 0 !important;
}

.historic-empty {
  height: 100%;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;

  padding-top: 120px;

  background: $pinIcon no-repeat center 39%;
}

.receipt {
  // background: $white;

  .title,
  div,
  strong,
  p {
    color: $black;
  }

  .title {
    margin-bottom: 20px;
    font-weight: bold;
    text-align: center;
    text-transform: uzppercase;
    font-size: $size-5;
  }
}

.loading {
  background: url("../../assets/loading.svg") no-repeat center 35%;
  background-size: 100px;
  text-align: center;
  padding: 7rem 0 0;
  font-size: $size-7;
  opacity: 0.5;
  margin-right: 1.75rem;
}

.notification {
  background: $black $cancelOrderIcon no-repeat 2rem center;
  padding: 2rem 2rem 2rem 7.5rem;
  text-align: center;
}

.body {
  text-align: center;
  margin: 2rem 0 1.5rem;

  .title {
    text-transform: uppercase;
    font-size: $size-6;
    margin-bottom: 0;
  }
}

.warning {
  color: $grey-light !important;
  font-size: $size-7;
  text-align: center;
}

.success {
  text-align: center;
  background: $successIcon no-repeat center 2rem;
  padding: 11rem 5rem 1rem;
}

.receipt-origin {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  padding: 30px;
  marginb-bottom: 1px;

  .icon {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-right: 30px;
    opacity: 1;

    &.payment-declined {
      > img {
        display: block;
        margin-top: 2px;
      }
      @each $city, $map in $cities {
        .is-#{$city} & {
          background-color: #ff3860;
        }
      }
    }

    @each $city, $map in $cities {
      .is-#{$city} & {
        background-color: map-get($map, "primary");
      }
    }
  }

  * {
    color: #000 !important;
  }

  > div {
    display: flex;
    flex-direction: column;

    &:last-child {
      margin-left: auto;
    }
  }
}

.receipt-description {
  & > span {
    font-weight: 700;
    color: #555;

    &:first-child {
      font-size: 11px;
      text-transform: uppercase;
      color: #4a4a4a !important;
    }

    &:last-child {
      font-size: 14px;
    }
  }
}

.receipt-date {
  text-align: right;
  & > span {
    color: #4a4a4a !important;
    font-size: 11px;
    font-weight: 700;
  }
}

.receipt-detail {
  background-color: #fff;
  padding: 20px 30px;
  margin-top: 2px;

  * {
    color: #000 !important;
  }

  > div {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .receipt-label {
    font-weight: 700;
    font-size: 10px;
    text-transform: uppercase;
    color: #4a4a4a !important;
  }

  .receipt-value {
    font-size: 14px;
    font-weight: 700;
  }

  .summary-icon > img {
    width: 22px;
    margin-right: 10px;
  }

  .summary-icon {
    display: inline-flex;
  }

  .receipt-amount {
    @each $city, $map in $cities {
      .is-#{$city} & {
        color: map-get($map, "primary") !important;
      }
    }

    &.payment-declined {
      @each $city, $map in $cities {
        .is-#{$city} & {
          color: #ff3860 !important;
        }
      }
    }
  }
}

.receipt-reference {
  margin-top: 2px;
  background-color: white;
  text-align: center;
  padding: 20px 30px;

  span {
    color: #000;
    display: block;

    font-weight: 700;

    &:first-child {
      font-size: 10px;
      text-transform: uppercase;
      color: #4a4a4a;
    }
  }
}

.receipt-footerNotes {
  background-color: white;
  padding: 20px 30px;
}
</style>
